import { render, staticRenderFns } from "./BankStatements.vue?vue&type=template&id=3ca62c07&scoped=true&"
import script from "./BankStatements.vue?vue&type=script&lang=ts&"
export * from "./BankStatements.vue?vue&type=script&lang=ts&"
import style0 from "./BankStatements.vue?vue&type=style&index=0&id=3ca62c07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca62c07",
  null
  
)

export default component.exports